import React, { Component, PropTypes } from 'react';
import { RaisedButton, Styles, TextField } from 'material-ui';
import Spinner from 'components/Material/Spinner';
import CoursioLogo from 'components/CoursioLogo';
import Message from 'services/Message';
import * as Colors from 'components/Material/Styles/Colors';

let { Spacing } = Styles;

export default class ForgotPasswordForm extends Component {
  state = {
    displayName: localStorage && localStorage.displayName,
    canSubmit: false
  };

  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    getIntlMessage: PropTypes.func
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  resetLogin() {
    this.setState({ displayName: null });
  }

  submit(e) {
    const password = this.refs.password.getValue();
    const confirm = this.refs.confirm.getValue();
    e.preventDefault();

    if (this.props.onSubmit) {
      this.props.onSubmit(password, confirm);
    }
  }

  change() {
    const password = this.refs.password.getValue();
    const confirm = this.refs.confirm.getValue();
    this.setState({ canSubmit: password && confirm && password === confirm });
  }

  render() {
    let button;
    if (this.state.loading) {
      button = (
        <RaisedButton fullWidth={true} secondary={true} disabled={true}>
          <Spinner />
        </RaisedButton>
      );
    } else {
      button = (
        <RaisedButton
          disabled={!this.state.canSubmit}
          fullWidth={true}
          label={this.context.getIntlMessage('Reset')}
          secondary={true}
          onTouchTap={this.submit.bind(this)}
        />
      );
    }

    return (
      <div className="login">
        <form onSubmit={this.submit.bind(this)}>
          <div style={{ textAlign: 'center' }}>
            <CoursioLogo initialFill="#09BEC3" />
            <h1
              style={{
                fontSize: '1.5em',
                color: Colors.Colors.grey[500].material,
                padding: Spacing.desktopGutterMini * 2
              }}
            >
              {this.context.getIntlMessage('password.reset')}
            </h1>
          </div>
          <TextField
            type="password"
            onChange={this.change.bind(this)}
            fullWidth={true}
            floatingLabelText={this.context.getIntlMessage(
              'password.newPassword'
            )}
            ref="password"
          />
          <TextField
            type="password"
            onChange={this.change.bind(this)}
            fullWidth={true}
            floatingLabelText={this.context.getIntlMessage('password.confirm')}
            ref="confirm"
          />
          {button}
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/RestorePasswordForm.js